import HeaderSubSection from "../../components/HeaderSubSection/index.vue";

export default {
  name: "howToUsePage",
  components: {
    HeaderSubSection,
  },
  methods:{
  }
};
